import styled from 'react-emotion';

const EntryType = styled('span')`
  margin: 0 10px 0 0;
  color: #fff;
  border-radius: 20px;
  padding: 0 8px;
  font-size: 12px;
  height: 20px;
  line-height: 19px;
  ${props => {
    switch (props.type) {
      case 'New':
        return `
          background: #3778ff;
          border: 1px solid #3778ff;
        `;
      case 'Improvement':
        return `
          background: #b26cee;
          border: 1px solid #b26cee;
        `;
      case 'Fix':
        return `
          background: #ff4772;
          border: 1px solid #ff4772;
        `;
      default:
        return `
          background: #f3f3f3;
          border: 1px solid #f3f3f3;
        `;
    }
  }};
`;

export default EntryType;
